import * as t from "io-ts"

export const TAvailabilityType = t.interface({
  constraintType: t.string,
  valueType: t.string
})

export const TAirportSeasonConfiguration = t.interface({
  season: t.string,
  country: t.string,
  airport: t.string,
  airportIcao: t.string,

  isDisabled: t.boolean,
  isLocked: t.boolean,
  isAvailDisabled: t.boolean,

  supportsIata: t.boolean,
  supportsIcao: t.boolean,

  // time types
  supportsLt: t.boolean, // airport season supports local time
  supportsUtc: t.boolean, // airport season supports UTC

  // controls by name - for FlightSelector, subset of primaryControls U secondaryControls
  hiddenControls: t.array(t.string), // unordered list of names of controls to hide
  disabledControls: t.array(t.string), // unordered list of names of controls to disable

  // flight pages only
  operatorRestricted: t.boolean, // if true, show operator drop down, otherwise show operator field
  operators: t.array(t.string), // own (or editable) operators: if [""], all operators; otherwise list of own operators (may be empty, [])
  serviceTypes: t.array(t.string), // if [""], no restrictions (all service types allowed), otherwise list of allowed st (may be empty, [])
  allowGcrRegMode: t.boolean, // allow REG mode on add GABA pages
  showACRegForServiceTypes: t.union([t.string, t.null]),

  // availability pages only
  unsupportedTypes: t.array(TAvailabilityType),
  supportsQuotaOverlay: t.boolean,
  supportsQuotaConstraints: t.boolean,
  supportsBaseline: t.boolean,
  peakWeekDate: t.string,

  // terminals
  supportsTerminalRequest: t.boolean,
  supportsRunwayTerminals: t.boolean,
  terminals: t.array(t.string),

  // download controls
  downloadHidden: t.boolean,
  exportHidden: t.boolean,
  supportsDownload: t.boolean,
  supportsExport: t.boolean,
  reportFormats: t.array(t.string),
  reportMultipleSumOf: t.boolean,
  reportSumByFields: t.array(t.string),

  // edit/add SHL only
  supportsShl: t.boolean,

  // slot monitoring only
  lastUpdated: t.string,

  // handling only
  handlers: t.array(t.string),
  parkingLocations: t.array(t.string)
})
export const TAirportSeasonConfigurations = t.array(TAirportSeasonConfiguration)

export type AirportSeasonConfiguration = t.TypeOf<
  typeof TAirportSeasonConfiguration
>
export type AirportSeasonConfigurations = t.TypeOf<
  typeof TAirportSeasonConfigurations
>
